import { IConfigService }                  from '@cs/performance-manager/shared';

export abstract class IframeTeaserConfigService implements IConfigService {

	moduleName = 'teaser';

}
